import { createContext } from "preact";

export const KeycloakContext = createContext();

export const useKeycloak = () => {
    return useContext(KeycloakContext);
};